import { CLASSES } from "@/scripts/helpers/constants";

export default () => {
  const cardsList = $(".advantages-cards"),
    cardsItem = $(".advantages-cards__item"),
    showMoreBtn = $(".js-show-more-items");

  if (cardsList.length) {
    cardsList.ready(function() {
      function hideItems() {
        let i = 0;

        cardsItem.each(function() {
          let windowSize = $(window).width(),
            // phone
            tabletBreakpoint = 639;

          i += 1;

          if (windowSize < tabletBreakpoint) {
            if (i > 3) {
              $(this).addClass(CLASSES.IS_HIDDEN);
            }
          }
        });
      }

      hideItems();

      $(".js-show-more-items").on("click", function(e) {
        let i = 0;
        e.preventDefault();

        $(".is-hidden").each(function() {
          i += 1;
          if (i <= 12) {
            $(this).removeClass(CLASSES.IS_HIDDEN);
          }
        });

        $(this).text($(this).text() == "Show all" ? "Show less" : "Show all");

        const cardsItemHidden = $(".advantages-cards__item.is-hidden");

        if (cardsItemHidden.length < 1 && !$(this).hasClass("less")) {
          showMoreBtn.addClass("less");
        } else {
          showMoreBtn.removeClass("less");
          hideItems();
          $("html, body").animate(
            {
              scrollTop: showMoreBtn.offset().top - 140
            },
            100
          );
        }
      });
    });
  }
};
